import { AUTHORSHIP_FIELD_NAMES } from '@cli-constants/generators.js'
export function isAuthorshipFieldName(name: string): boolean {
  return (AUTHORSHIP_FIELD_NAMES as readonly string[]).includes(name)
}
